module.exports = __webpack_public_path__ + "img/icon_select_search.b27fbb53.svg";